import React from "react";

/**
 * Return the Authentication context
 */
const AuthContext = React.createContext({});
export {
	AuthContext,
}
